/* ========================================
   THE GURUMI — THEME JS v1.0
   GÜNKAYA SOFTWARE
======================================== */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  /* ========================================
     MODULE 1: PARALLAX ENGINE
     ======================================== */
  const parallaxElements = document.querySelectorAll('.hero__parallax-bg');
  let parallaxTicking = false;
  const isMobile = window.innerWidth < 768;

  function updateParallax() {
    if (isMobile) { parallaxTicking = false; return; }
    const scrollY = window.scrollY;
    parallaxElements.forEach(el => {
      const section = el.closest('section');
      if (!section) return;
      const rect = section.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const sectionTop = rect.top + scrollY;
      const offset = (scrollY - sectionTop) * 0.3;
      el.style.transform = 'translate3d(0,' + offset + 'px,0)';
    });
    parallaxTicking = false;
  }

  window.addEventListener('scroll', () => {
    if (!parallaxTicking) { requestAnimationFrame(updateParallax); parallaxTicking = true; }
  }, { passive: true });

  /* ========================================
     MODULE 2: INTERSECTION OBSERVER (SCROLL ANIMATIONS)
     ======================================== */
  const scrollObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-animate--visible');
        scrollObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.scroll-animate').forEach(el => scrollObserver.observe(el));

  /* ========================================
     MODULE 3: STICKY HEADER
     ======================================== */
  const header = document.getElementById('siteHeader');
  const announcementBar = document.getElementById('announcementBar');
  function handleHeaderScroll() {
    if (!header) return;
    if (window.scrollY > 60) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }
  }
  window.addEventListener('scroll', handleHeaderScroll, { passive: true });
  handleHeaderScroll();

  /* ========================================
     MODULE 4: MOBILE MENU
     ======================================== */
  const menuToggle = document.getElementById('menuToggle');
  const mobileMenu = document.getElementById('mobileMenu');
  const mobileMenuClose = document.getElementById('mobileMenuClose');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('mobile-menu--open');
    document.body.style.overflow = 'hidden';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('mobile-menu--open');
    document.body.style.overflow = '';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    // Reset all accordions when menu closes
    document.querySelectorAll('.mobile-menu__accordion-toggle').forEach(toggle => {
      toggle.classList.remove('active');
      toggle.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.mobile-menu__accordion-content').forEach(content => {
      content.classList.remove('open');
    });
  }

  // Mobile menu accordion toggles
  document.querySelectorAll('.mobile-menu__accordion-toggle').forEach(toggle => {
    toggle.addEventListener('click', function () {
      const accordion = this.closest('.mobile-menu__accordion');
      const content = accordion ? accordion.querySelector('.mobile-menu__accordion-content') : null;
      if (!content) return;
      const isOpen = content.classList.contains('open');
      if (isOpen) {
        content.classList.remove('open');
        this.classList.remove('active');
        this.setAttribute('aria-expanded', 'false');
      } else {
        content.classList.add('open');
        this.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMenu);
  document.querySelectorAll('.mobile-menu__link').forEach(link => {
    link.addEventListener('click', closeMenu);
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && mobileMenu) closeMenu(); });

  /* ========================================
     MODULE 6: REVIEWS CAROUSEL
     ======================================== */
  const reviewsTrack = document.getElementById('reviewsTrack');
  const reviewsDots = document.querySelectorAll('.reviews__dot');
  const prevArrow = document.querySelector('.reviews__arrow--prev');
  const nextArrow = document.querySelector('.reviews__arrow--next');
  const reviewCards = reviewsTrack ? reviewsTrack.querySelectorAll('.review-card') : [];
  let currentSlide = 0;
  let autoplayInterval;

  function getSlidesPerView() {
    return window.innerWidth < 768 ? 1 : 3;
  }

  function getMaxSlide() {
    return Math.max(0, reviewCards.length - getSlidesPerView());
  }

  function goToSlide(index) {
    const max = getMaxSlide();
    if (index < 0) index = max;
    if (index > max) index = 0;
    currentSlide = index;
    if (reviewCards.length === 0) return;
    const card = reviewCards[0];
    const style = getComputedStyle(card);
    const cardWidth = card.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight);
    reviewsTrack.style.transform = 'translateX(-' + (currentSlide * cardWidth) + 'px)';
    reviewsDots.forEach((d, i) => d.classList.toggle('reviews__dot--active', i === currentSlide));
  }

  if (prevArrow) prevArrow.addEventListener('click', () => { goToSlide(currentSlide - 1); resetAutoplay(); });
  if (nextArrow) nextArrow.addEventListener('click', () => { goToSlide(currentSlide + 1); resetAutoplay(); });
  reviewsDots.forEach(dot => {
    dot.addEventListener('click', () => { goToSlide(parseInt(dot.dataset.index)); resetAutoplay(); });
  });

  // Touch swipe
  let touchStartX = 0;
  if (reviewsTrack) {
    reviewsTrack.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
    reviewsTrack.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goToSlide(currentSlide + 1) : goToSlide(currentSlide - 1);
        resetAutoplay();
      }
    }, { passive: true });
  }

  // Autoplay
  function startAutoplay() { autoplayInterval = setInterval(() => goToSlide(currentSlide + 1), 4500); }
  function stopAutoplay() { clearInterval(autoplayInterval); }
  function resetAutoplay() { stopAutoplay(); startAutoplay(); }
  startAutoplay();

  const carousel = document.getElementById('reviewsCarousel');
  if (carousel) {
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
  }

  // Recalculate on resize
  window.addEventListener('resize', () => { goToSlide(currentSlide); });

  /* ========================================
     MODULE 7: COUNTUP ANIMATION
     ======================================== */
  function animateCountUp(el) {
    const target = parseFloat(el.dataset.count);
    const isDecimal = el.dataset.decimal === 'true';
    const duration = 2000;
    const start = performance.now();

    function update(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = eased * target;
      el.textContent = isDecimal ? current.toFixed(1) : Math.floor(current).toLocaleString('tr-TR');
      if (progress < 1) requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  const statsSection = document.getElementById('stats');
  if (statsSection) {
    const countObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('[data-count]').forEach(animateCountUp);
          countObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    countObserver.observe(statsSection);
  }

  /* ========================================
     MODULE 8: 3D TILT ON PRODUCT CARDS
     ======================================== */
  if (!('ontouchstart' in window)) {
    document.querySelectorAll('[data-tilt]').forEach(card => {
      card.addEventListener('mousemove', e => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = ((y - centerY) / centerY) * -4;
        const rotateY = ((x - centerX) / centerX) * 4;
        card.style.transform = 'perspective(800px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-5px)';
        card.style.transition = 'none';
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
        card.style.transition = 'transform 0.4s ease';
      });
    });
  }

  /* ========================================
     MODULE 9: SMOOTH SCROLL
     ======================================== */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      const href = anchor.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const headerH = header ? header.offsetHeight : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - headerH - 10;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  /* ========================================
     MODULE 11: NEWSLETTER FORM
     ======================================== */
  const newsletterForm = document.getElementById('newsletterForm');
  const newsletterSuccess = document.getElementById('newsletterSuccess');

  if (newsletterForm) {
    newsletterForm.addEventListener('submit', e => {
      e.preventDefault();
      newsletterForm.style.display = 'none';
      if (newsletterSuccess) newsletterSuccess.style.display = 'block';
    });
  }

  /* ========================================
     MODULE 12: FOOTER ACCORDION (MOBILE)
     ======================================== */
  document.querySelectorAll('.footer__accordion-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const col = btn.closest('.footer__col');
      const isOpen = col.classList.contains('footer__col--open');
      document.querySelectorAll('.footer__col--open').forEach(c => {
        c.classList.remove('footer__col--open');
        const toggle = c.querySelector('.footer__accordion-toggle span');
        if (toggle) toggle.textContent = '+';
        c.querySelector('.footer__accordion-toggle').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        col.classList.add('footer__col--open');
        btn.querySelector('span').textContent = '\u2212';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });


  /* ========================================
     PAGE MODULE: COLLECTION PAGE
     (Sadece sayfaya özel kod — global modüller yukarıda çalışıyor)
  ======================================== */
  if (document.querySelector('.collection-layout')) {
    /* Filter Drawer (Mobile) */
    const filterToggle = document.getElementById('filterToggle');
    const filterDrawer = document.getElementById('filterDrawer');
    const filterBackdrop = document.getElementById('filterBackdrop');
    const filterDrawerClose = document.getElementById('filterDrawerClose');
    const filterDrawerApply = document.getElementById('filterDrawerApply');

    function openFilterDrawer() {
      if (filterDrawer) filterDrawer.classList.add('filter-drawer--open');
      if (filterBackdrop) filterBackdrop.classList.add('filter-drawer__backdrop--open');
      document.body.style.overflow = 'hidden';
    }
    function closeFilterDrawer() {
      if (filterDrawer) filterDrawer.classList.remove('filter-drawer--open');
      if (filterBackdrop) filterBackdrop.classList.remove('filter-drawer__backdrop--open');
      document.body.style.overflow = '';
    }
    if (filterToggle) filterToggle.addEventListener('click', openFilterDrawer);
    if (filterDrawerClose) filterDrawerClose.addEventListener('click', closeFilterDrawer);
    if (filterBackdrop) filterBackdrop.addEventListener('click', closeFilterDrawer);
    if (filterDrawerApply) filterDrawerApply.addEventListener('click', closeFilterDrawer);

    /* Filter Checkbox Toggle */
    document.querySelectorAll('.filter-group__item input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var label = cb.closest('.filter-group__item');
        if (label) {
          if (cb.checked) {
            label.classList.add('filter-group__item--checked');
          } else {
            label.classList.remove('filter-group__item--checked');
          }
        }
      });
    });

    /* Color Swatch Toggle */
    document.querySelectorAll('.filter-group__color').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatch.classList.toggle('filter-group__color--active');
      });
    });

    /* Sort Dropdown */
    function setupSort(toggleId, optionsId) {
      const toggle = document.getElementById(toggleId);
      const options = document.getElementById(optionsId);
      if (!toggle || !options) return;
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        options.classList.toggle('toolbar__sort-options--open');
      });
    }
    setupSort('sortToggleMobile', 'sortOptionsMobile');
    setupSort('sortToggleDesktop', 'sortOptionsDesktop');

    document.addEventListener('click', function () {
      document.querySelectorAll('.toolbar__sort-options--open').forEach(function (el) {
        el.classList.remove('toolbar__sort-options--open');
      });
    });

    /* Active Filter Tags */
    document.querySelectorAll('.js-remove-tag').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tagToRemove = btn.getAttribute('data-tag');
        // Uncheck all checkboxes with this value
        document.querySelectorAll('.js-tag-filter[value="' + tagToRemove + '"]').forEach(function (cb) {
          cb.checked = false;
        });
        // We trigger form submission via the desktop form (or mobile if it exists)
        var form = document.getElementById('filterFormDesktop') || document.getElementById('filterFormMobile');
        if (form) {
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    });
    const clearAll = document.getElementById('clearAllFilters');
    if (clearAll) {
      clearAll.addEventListener('click', function () {
        const filters = document.getElementById('activeFilters');
        if (filters) filters.innerHTML = '';
      });
    }

    /* ── Collapsible Filter Group Titles ── */
    document.querySelectorAll('.filter-group__title--collapsible').forEach(function (title) {
      const targetId = title.dataset.target;
      const body = targetId ? document.getElementById(targetId) : null;
      if (!body) return;

      // Set initial max-height for animation from open state
      body.style.maxHeight = body.scrollHeight + 'px';

      title.addEventListener('click', function () {
        const isCollapsed = title.classList.contains('is-collapsed');
        if (isCollapsed) {
          // Expand
          title.classList.remove('is-collapsed');
          body.classList.remove('filter-group__body--collapsed');
          body.style.maxHeight = body.scrollHeight + 'px';
        } else {
          // Collapse
          title.classList.add('is-collapsed');
          body.style.maxHeight = body.scrollHeight + 'px'; // set explicit before collapsing
          requestAnimationFrame(function () {
            body.classList.add('filter-group__body--collapsed');
          });
        }
      });
    });

    /* ── Form Submit & Tag URL Generation ── */
    ['filterFormDesktop', 'filterFormMobile'].forEach(function (formId) {
      var form = document.getElementById(formId);
      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var checkedTags = [];
        form.querySelectorAll('.js-tag-filter:checked').forEach(function (cb) {
          checkedTags.push(cb.value);
        });

        var baseUrl = form.getAttribute('action') || window.location.pathname;

        if (baseUrl.indexOf('?') > -1) {
          baseUrl = baseUrl.split('?')[0];
        }

        if (checkedTags.length > 0) {
          if (baseUrl.charAt(baseUrl.length - 1) === '/') {
            baseUrl = baseUrl.slice(0, -1);
          }
          baseUrl += '/' + checkedTags.join('+');
        }

        var searchString = '';
        var inputs = form.querySelectorAll('input:not(.js-tag-filter), select');
        inputs.forEach(function (inp) {
          if (inp.name && inp.value && (inp.type !== 'checkbox' || inp.checked) && (inp.type !== 'radio' || inp.checked)) {
            searchString += (searchString === '' ? '?' : '&') + encodeURIComponent(inp.name) + '=' + encodeURIComponent(inp.value);
          }
        });

        window.location.href = baseUrl + searchString;
      });
    });

    /* ── Active filter count badge on mobile toggle button ── */
    (function () {
      var activeCount = document.querySelectorAll(
        '#filterFormDesktop input[type="checkbox"]:checked, #filterFormDesktop input[type="number"]'
      ).length;
      // Count checked boxes only
      activeCount = document.querySelectorAll('#filterFormDesktop input[type="checkbox"]:checked').length;
      // Also count applied price filters
      document.querySelectorAll('#filterFormDesktop input[type="number"]').forEach(function (inp) {
        if (inp.value !== '') activeCount++;
      });
      if (activeCount > 0) {
        var btn = document.getElementById('filterToggle');
        if (btn) {
          var badge = document.createElement('span');
          badge.className = 'toolbar__filter-badge';
          badge.textContent = activeCount;
          btn.appendChild(badge);
        }
      }
    })();
  }



  /* ========================================
     PAGE MODULE: PRODUCT DETAIL PAGE
     (Sadece sayfaya özel kod — global modüller yukarıda çalışıyor)
  ======================================== */
  if (document.querySelector('.pd-gallery')) {
    /* Gallery Thumbnails */
    const mainImg = document.getElementById('pdMainImg');
    const thumbs = document.querySelectorAll('.pd-gallery__thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('pd-gallery__thumb--active'); });
        thumb.classList.add('pd-gallery__thumb--active');
        if (mainImg) mainImg.src = thumb.dataset.img;
      });
    });

    /* Gallery Zoom on Hover */
    const mainImageContainer = document.getElementById('pdMainImage');
    if (mainImageContainer && mainImg && window.innerWidth >= 768) {
      mainImageContainer.addEventListener('mousemove', function (e) {
        const rect = mainImageContainer.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
      });
    }

    /* Wishlist Toggle */
    const wishlistBtn = document.getElementById('pdWishlist');
    if (wishlistBtn) {
      wishlistBtn.addEventListener('click', function () {
        wishlistBtn.classList.toggle('pd-gallery__wishlist--active');
        const isFilled = wishlistBtn.classList.contains('pd-gallery__wishlist--active');
        const svg = wishlistBtn.querySelector('svg');
        if (svg) svg.setAttribute('fill', isFilled ? 'currentColor' : 'none');
      });
    }

    /* Color Swatch Variant Selector */
    var variantsJson = document.getElementById('productVariantsJson');
    var productVariants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var colorSwatches = document.querySelectorAll('.pd-colors__swatch');
    var colorName = document.getElementById('colorName');
    var variantIdInput = document.getElementById('variantId');

    // Get current selected options
    function getSelectedOptions() {
      var options = [];
      // Color option
      var activeSwatch = document.querySelector('.pd-colors__swatch--active');
      if (activeSwatch) {
        options.push(activeSwatch.dataset.color);
      }
      // Other options (radio buttons)
      document.querySelectorAll('.pd-option__value input[type="radio"]:checked').forEach(function (radio) {
        options.push(radio.value);
      });
      return options;
    }

    function findMatchingVariant(options) {
      if (!productVariants.length) return null;
      for (var i = 0; i < productVariants.length; i++) {
        var v = productVariants[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (v.options && v.options[j] !== options[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function updateVariant() {
      var options = getSelectedOptions();
      var variant = findMatchingVariant(options);
      if (variant && variantIdInput) {
        variantIdInput.value = variant.id;
        // Update price display
        var priceEl = document.querySelector('.pd-info__price');
        if (priceEl) {
          priceEl.textContent = (variant.price / 100).toFixed(2).replace('.', ',') + 'TL';
        }
        // Update availability
        var addBtn = document.getElementById('addToCart');
        var buyBtn = document.getElementById('buyNow');
        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:20px;height:20px"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Sepete Ekle';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Tükendi';
          }
        }
        if (buyBtn) {
          buyBtn.style.display = variant.available ? '' : 'none';
        }
      }
    }

    colorSwatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        colorSwatches.forEach(function (s) { s.classList.remove('pd-colors__swatch--active'); });
        swatch.classList.add('pd-colors__swatch--active');
        if (colorName) colorName.textContent = swatch.dataset.color;
        updateVariant();
      });
    });

    // Other option radio buttons
    document.querySelectorAll('.pd-option__value input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        document.querySelectorAll('.pd-option__value').forEach(function (label) {
          label.classList.remove('pd-option__value--selected');
        });
        radio.closest('.pd-option__value').classList.add('pd-option__value--selected');
        updateVariant();
      });
    });

    /* Buy Now Button */
    var buyNowBtn = document.getElementById('buyNow');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        var form = document.getElementById('productForm');
        if (form) {
          // Submit to cart then redirect to checkout
          var formData = new FormData(form);
          fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          }).then(function () {
            window.location.href = '/checkout';
          }).catch(function () {
            form.submit();
          });
        }
      });
    }

    /* Quantity Selector */
    const qtyInput = document.getElementById('qtyInput');
    const qtyMinus = document.getElementById('qtyMinus');
    const qtyPlus = document.getElementById('qtyPlus');
    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        const val = parseInt(qtyInput.value);
        if (val > 1) qtyInput.value = val - 1;
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        const val = parseInt(qtyInput.value);
        if (val < 10) qtyInput.value = val + 1;
      });
    }

    /* Add to Cart — AJAX (yönlendirme yok) */
    const productForm = document.getElementById('productForm');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const addToCartBtn = document.getElementById('addToCart');
        if (!addToCartBtn || addToCartBtn.disabled) return;
        addToCartBtn.disabled = true;
        var formData = new FormData(productForm);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          addToCartBtn.innerHTML = '&#10003; Sepete Eklendi!';
          addToCartBtn.style.background = 'var(--color-accent)';
          addToCartBtn.style.borderColor = 'var(--color-accent)';
          updateCartBadge();
          showCartToast(item.title || 'Ürün');
          setTimeout(function () {
            addToCartBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:20px;height:20px"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Sepete Ekle';
            addToCartBtn.style.background = '';
            addToCartBtn.style.borderColor = '';
            addToCartBtn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          addToCartBtn.disabled = false;
          alert('Ürün sepete eklenirken bir hata oluştu.');
        });
      });
    }

    /* Tabs */
    const tabBtns = document.querySelectorAll('.pd-tabs__btn');
    const tabPanels = document.querySelectorAll('.pd-tabs__panel');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabBtns.forEach(function (b) { b.classList.remove('pd-tabs__btn--active'); b.setAttribute('aria-selected', 'false'); });
        tabPanels.forEach(function (p) { p.classList.remove('pd-tabs__panel--active'); });
        btn.classList.add('pd-tabs__btn--active');
        btn.setAttribute('aria-selected', 'true');
        const panel = document.getElementById('tab-' + btn.dataset.tab);
        if (panel) panel.classList.add('pd-tabs__panel--active');
      });
    });

    /* Product FAQ Accordion */
    document.querySelectorAll('.pd-faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const item = btn.closest('.pd-faq__item');
        const isOpen = item.classList.contains('pd-faq__item--open');
        document.querySelectorAll('.pd-faq__item--open').forEach(function (i) {
          i.classList.remove('pd-faq__item--open');
          i.querySelector('.pd-faq__question').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('pd-faq__item--open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* Reviews System */
    const starBtns = document.querySelectorAll('.reviews-form__star');
    let selectedRating = 0;
    starBtns.forEach(function (star) {
      star.addEventListener('mouseenter', function () {
        const rating = parseInt(this.dataset.rating);
        starBtns.forEach(function (s) {
          s.textContent = parseInt(s.dataset.rating) <= rating ? '\u2605' : '\u2606';
          s.classList.toggle('reviews-form__star--active', parseInt(s.dataset.rating) <= rating);
        });
      });
      star.addEventListener('click', function () {
        selectedRating = parseInt(this.dataset.rating);
        starBtns.forEach(function (s) {
          s.textContent = parseInt(s.dataset.rating) <= selectedRating ? '\u2605' : '\u2606';
          s.classList.toggle('reviews-form__star--active', parseInt(s.dataset.rating) <= selectedRating);
        });
      });
    });
    const starsContainer = document.getElementById('reviewStarInput');
    if (starsContainer) {
      starsContainer.addEventListener('mouseleave', function () {
        starBtns.forEach(function (s) {
          s.textContent = parseInt(s.dataset.rating) <= selectedRating ? '\u2605' : '\u2606';
          s.classList.toggle('reviews-form__star--active', parseInt(s.dataset.rating) <= selectedRating);
        });
      });
    }

    // Render reviews helper
    function renderReviews(reviews) {
      const list = document.getElementById('reviewList');
      const empty = document.getElementById('reviewEmpty');
      const avgEl = document.getElementById('reviewAvg');
      const countEl = document.getElementById('reviewCount');
      const summaryStars = document.querySelector('.reviews-summary__stars');

      if (!reviews || reviews.length === 0) {
        if (empty) empty.style.display = 'block';
        return;
      }
      if (empty) empty.style.display = 'none';

      // Calculate average
      const total = reviews.reduce(function (sum, r) { return sum + r.rating; }, 0);
      const avg = (total / reviews.length).toFixed(1);
      if (avgEl) avgEl.textContent = avg;
      if (countEl) countEl.textContent = reviews.length + ' de\u011ferlendirme';

      // Update summary stars
      if (summaryStars) {
        const fullStars = Math.round(parseFloat(avg));
        summaryStars.innerHTML = '';
        for (let i = 1; i <= 5; i++) {
          const span = document.createElement('span');
          span.className = i <= fullStars ? 'star star--filled' : 'star';
          span.textContent = i <= fullStars ? '\u2605' : '\u2606';
          summaryStars.appendChild(span);
        }
      }

      // Update bars
      const starCounts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      reviews.forEach(function (r) { starCounts[r.rating] = (starCounts[r.rating] || 0) + 1; });
      for (let s = 1; s <= 5; s++) {
        const fill = document.querySelector('.reviews-bar__fill[data-star="' + s + '"]');
        const count = document.querySelector('.reviews-bar__count[data-star-count="' + s + '"]');
        if (fill) fill.style.width = (reviews.length ? (starCounts[s] / reviews.length * 100) : 0) + '%';
        if (count) count.textContent = starCounts[s];
      }

      // Render cards
      let cardsHtml = '';
      reviews.forEach(function (r) {
        let stars = '';
        for (let i = 1; i <= 5; i++) stars += i <= r.rating ? '\u2605' : '\u2606';
        cardsHtml += '<div class="review-card"><div class="review-card__header">' +
          '<div class="review-card__avatar" style="background:' + (r.color || '#971714') + '">' + (r.initials || '\u00dcY') + '</div>' +
          '<div class="review-card__meta"><span class="review-card__name">' + r.name + '</span>' +
          '<span class="review-card__date">' + r.date + '</span></div>' +
          '<div class="review-card__stars">' + stars + '</div></div>' +
          '<p class="review-card__text">' + r.text + '</p>' +
          (r.verified ? '<span class="review-card__verified">\u2713 Do\u011frulanm\u0131\u015f Al\u0131\u015f Veri\u015f</span>' : '') +
          '</div>';
      });
      if (list) {
        list.innerHTML = '<div class="reviews-empty" id="reviewEmpty" style="display:none"><p>Hen\u00fcz yorum yap\u0131lmam\u0131\u015f. \u0130lk yorumu siz yap\u0131n! \ud83c\udf89</p></div>' + cardsHtml;
      }
    }

    // Review form submission (demo - stores in localStorage)
    const reviewFormInner = document.getElementById('reviewFormInner');
    if (reviewFormInner) {
      reviewFormInner.addEventListener('submit', function (e) {
        e.preventDefault();
        const text = document.getElementById('reviewText').value.trim();
        if (!text || selectedRating === 0) {
          alert('L\u00fctfen puan verin ve yorumunuzu yaz\u0131n.');
          return;
        }
        const productName = document.title.split(' \u2014 ')[0];
        let reviews = JSON.parse(localStorage.getItem('gurumi_reviews_' + productName) || '[]');
        reviews.unshift({
          name: '\u00dcye',
          initials: '\u00dcY',
          rating: selectedRating,
          text: text,
          date: new Date().toLocaleDateString('tr-TR'),
          verified: true,
          color: ['#971714', '#2563EB', '#10B981', '#F97316', '#9333EA'][Math.floor(Math.random() * 5)]
        });
        localStorage.setItem('gurumi_reviews_' + productName, JSON.stringify(reviews));
        document.getElementById('reviewText').value = '';
        selectedRating = 0;
        starBtns.forEach(function (s) { s.textContent = '\u2606'; s.classList.remove('reviews-form__star--active'); });
        renderReviews(reviews);
      });
    }

    // Load reviews on page load
    const productName = document.title.split(' \u2014 ')[0];
    const savedReviews = JSON.parse(localStorage.getItem('gurumi_reviews_' + productName) || '[]');
    renderReviews(savedReviews);
  }


  /* ========================================
     GLOBAL: AJAX Add to Cart for Product Cards
     (Koleksiyon / ana sayfa kartlarındaki sepete ekle butonları)
  ======================================== */
  document.querySelectorAll('.product-card form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      var originalText = btn.textContent;
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        btn.textContent = '✓ EKLENDİ!';
        btn.style.background = 'var(--color-accent, #10B981)';
        btn.style.color = '#fff';
        btn.style.borderColor = 'var(--color-accent, #10B981)';
        updateCartBadge();
        showCartToast(item.title || 'Ürün');
        setTimeout(function () {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.style.color = '';
          btn.style.borderColor = '';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.disabled = false;
        alert('Ürün sepete eklenirken bir hata oluştu.');
      });
    });
  });


  /* ========================================
     GLOBAL HELPERS: Cart Badge Update & Toast
  ======================================== */
function updateCartBadge() {
    // Cache bypass için timestamp ekle
    fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
          badge.textContent = count;
          badge.setAttribute('data-cart-count', count);
          badge.classList.add('cart-badge--pulse');
          setTimeout(function () { badge.classList.remove('cart-badge--pulse'); }, 600);
        });
      });
  }

  function showCartToast(productTitle) {
    // Remove existing toast
    var existing = document.getElementById('cartToast');
    if (existing) existing.remove();

    var isWarning = productTitle.indexOf('⚠️') === 0;
    var displayText = isWarning ? productTitle.replace('⚠️ ', '') : ('<strong>' + productTitle + '</strong> sepete eklendi!');
    var iconBg = isWarning ? '#F97316' : 'var(--color-accent)';
    var iconSymbol = isWarning ? '!' : '✓';

    var toast = document.createElement('div');
    toast.id = 'cartToast';
    toast.className = 'cart-toast';
    toast.innerHTML =
      '<div class="cart-toast__inner">' +
        '<div class="cart-toast__icon" style="background:' + iconBg + '">' + iconSymbol + '</div>' +
        '<div class="cart-toast__text">' + displayText + '</div>' +
        (isWarning ? '' : '<a href="/cart" class="cart-toast__btn">Sepete Git</a>') +
        '<button class="cart-toast__close" aria-label="Kapat">&times;</button>' +
      '</div>';
    document.body.appendChild(toast);

    // Trigger animation
    requestAnimationFrame(function () {
      toast.classList.add('cart-toast--visible');
    });

    // Close button
    toast.querySelector('.cart-toast__close').addEventListener('click', function () {
      toast.classList.remove('cart-toast--visible');
      setTimeout(function () { toast.remove(); }, 400);
    });

    // Auto dismiss
    setTimeout(function () {
      if (document.getElementById('cartToast')) {
        toast.classList.remove('cart-toast--visible');
        setTimeout(function () { toast.remove(); }, 400);
      }
    }, isWarning ? 4000 : 5000);
  }


  /* Duplicate collection page module removed — handled above in line 297 */


  /* ========================================
     PAGE MODULE: CART PAGE
     (Sadece sayfaya özel kod — AJAX tabanlı, sayfa yenilemesiz)
     Shopify AJAX API: id (item.key) kullanılır, line deprecated.
  ========================================*/
  if (document.querySelector('.cart-page')) {

    /* ── Helper: Fiyat formatlama (Shopify kuruş cinsinden tutar) ── */
    function formatMoney(cents) {
      return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
    }



/* ── Helper: Sepet toplamlarını güncelle ── */
    function refreshCartTotals(cart) {
      console.log('Cart data:', cart); // DEBUG - sonra silinecek
      
      // Güvenli fiyat al - hangisi mevcutsa onu kullan
      var subtotal = cart.items_subtotal_price || cart.original_total_price || cart.total_price || 0;
      var total = cart.total_price || cart.original_total_price || cart.items_subtotal_price || 0;
      
      // Ara toplam
      var subtotalRow = document.querySelector('.cart-summary__row:first-child span:last-child');
      if (subtotalRow) {
        subtotalRow.textContent = formatMoney(subtotal);
      }
      
      // Toplam
      var totalRow = document.querySelector('.cart-summary__row--total span:last-child');
      if (totalRow) {
        totalRow.textContent = formatMoney(total);
      }
      
      updateCartBadge();
    }
      


    /* ── Helper: Tek ürünün satır toplamını güncelle ── */
    function updateLineItemByKey(cartItem, cartData, key) {
      var item = null;
      for (var i = 0; i < cartData.items.length; i++) {
        if (cartData.items[i].key === key) { item = cartData.items[i]; break; }
      }
      if (!item) return;
      var totalEl = cartItem.querySelector('.cart-item__total .price--current');
      if (totalEl) totalEl.textContent = formatMoney(item.final_line_price);
    }

    /* ── Helper: Sepet boşsa sayfayı boş göster ── */
    function showEmptyCart() {
      var section = document.querySelector('.cart-page').closest('form');
      if (section) {
        section.outerHTML =
          '<div class="cart-empty" style="text-align:center;padding:3rem 0">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:64px;height:64px;margin:0 auto 1rem;color:var(--color-text-light)"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
            '<h2 style="margin-bottom:0.5rem">Sepetiniz Boş</h2>' +
            '<p style="color:var(--color-text-light);margin-bottom:1.5rem">Sepetinizde henüz ürün bulunmuyor.</p>' +
            '<a href="/" class="btn btn--primary btn--lg">Alışverişe Başla</a>'  +
          '</div>';
      }
      updateCartBadge();
    }

    /* ── Miktar butonları (+/-) ── */
    document.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.pd-qty__control');
        var input = wrap ? wrap.querySelector('.pd-qty__input') : null;
        if (!input) return;

        var oldVal = parseInt(input.value) || 1;
        var val = oldVal;
        var action = btn.getAttribute('data-action');
        var maxVal = parseInt(input.max) || 99;

        if (action === 'minus') val--;
        else if (action === 'plus' && val < maxVal) val++;

        if (val < 0) val = 0;
        input.value = val;

        var cartItem = btn.closest('.cart-item');
        var key = btn.getAttribute('data-key') || (cartItem ? cartItem.getAttribute('data-key') : null);
        if (!key) return;

        // Tüm butonları geçici devre dışı bırak
        var allBtns = cartItem ? cartItem.querySelectorAll('.cart-qty-btn') : [];
        allBtns.forEach(function (b) { b.disabled = true; });
        if (cartItem) cartItem.style.opacity = '0.6';

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: val })
        })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, status: r.status, data: data };
          });
        })
        .then(function (result) {
          // Shopify 422 = stok yetersiz
          if (!result.ok || result.data.status === 422) {
            input.value = oldVal;
            if (cartItem) cartItem.style.opacity = '1';
            allBtns.forEach(function (b) { b.disabled = false; });
            var errMsg = (result.data && result.data.description) ? result.data.description : 'Bu üründen daha fazla ekleyemezsiniz (stok yetersiz).';
            showCartToast('⚠️ ' + errMsg);
            return;
          }

          var cart = result.data;
          if (val === 0 || cart.items.length < document.querySelectorAll('.cart-item').length) {
            // Ürün silindi
            if (cart.item_count === 0) {
              showEmptyCart();
              return;
            }
            if (cartItem) {
              cartItem.style.transition = 'all 0.3s ease';
              cartItem.style.opacity = '0';
              cartItem.style.transform = 'translateX(-30px)';
              setTimeout(function () { cartItem.remove(); }, 300);
            }
          } else {
            // Miktar güncellendi
            if (cartItem) {
              cartItem.style.opacity = '1';
              updateLineItemByKey(cartItem, cart, key);
            }
            allBtns.forEach(function (b) { b.disabled = false; });
          }
          refreshCartTotals(cart);
        })
        .catch(function () {
          if (cartItem) cartItem.style.opacity = '1';
          allBtns.forEach(function (b) { b.disabled = false; });
          input.value = oldVal;
        });
      });
    });

    /* ── Input'a direkt değer girme ── */
    var qtyChangeTimers = {};
    document.querySelectorAll('.cart-item .pd-qty__input').forEach(function (input) {
      input.addEventListener('change', function () {
        var cartItem = input.closest('.cart-item');
        var key = cartItem ? cartItem.getAttribute('data-key') : null;
        if (!key) return;

        var val = parseInt(input.value) || 0;
        if (val < 0) val = 0;
        var maxVal = parseInt(input.max) || 99;
        if (val > maxVal) val = maxVal;
        input.value = val;

        if (qtyChangeTimers[key]) clearTimeout(qtyChangeTimers[key]);
        qtyChangeTimers[key] = setTimeout(function () {
          if (cartItem) cartItem.style.opacity = '0.6';
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: val })
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (val === 0 || cart.item_count === 0) {
              if (cart.item_count === 0) { showEmptyCart(); return; }
              if (cartItem) {
                cartItem.style.transition = 'all 0.3s ease';
                cartItem.style.opacity = '0';
                cartItem.style.transform = 'translateX(-30px)';
                setTimeout(function () { cartItem.remove(); }, 300);
              }
            } else {
              if (cartItem) {
                cartItem.style.opacity = '1';
                updateLineItemByKey(cartItem, cart, key);
              }
            }
            refreshCartTotals(cart);
          })
          .catch(function () {
            if (cartItem) cartItem.style.opacity = '1';
          });
        }, 400);
      });
    });

    /* ── Ürün silme butonu ── */
/* ── Ürün silme butonu (race condition önlenmiş - kuyruk sistemi) ── */
/* ── Ürün silme butonu (Event Delegation + Kuyruk) ── */
/* ── Ürün silme butonu (Event Delegation + Kuyruk) ── */
/* ── Ürün silme butonu (Key yenileme + Kuyruk) ── */
    var removeQueue = Promise.resolve();
    
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-item__remove');
      if (!btn) return;
      if (!document.querySelector('.cart-page')) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      if (btn.disabled || btn.dataset.removing === 'true') return;
      
      var cartItem = btn.closest('.cart-item');
      var key = cartItem ? cartItem.getAttribute('data-key') : null;
      if (!key) return;

      btn.disabled = true;
      btn.dataset.removing = 'true';
      btn.style.pointerEvents = 'none';
      
      if (cartItem) {
        cartItem.style.transition = 'all 0.3s ease';
        cartItem.style.opacity = '0.4';
      }

      removeQueue = removeQueue.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
        .then(function (r) {
          if (!r.ok) {
            // 400 hatası — key geçersiz, sepeti yeniden çek
            return fetch('/cart.js').then(function(r2) { return r2.json(); });
          }
          return r.json();
        })
        .then(function (cart) {
          if (cart.item_count === 0) {
            if (typeof showEmptyCart === 'function') showEmptyCart();
            return;
          }
          
          // Görsel olarak kaldır
          if (cartItem && cartItem.parentNode) {
            cartItem.style.opacity = '0';
            cartItem.style.transform = 'translateX(-30px)';
            setTimeout(function () {
              if (cartItem.parentNode) cartItem.parentNode.removeChild(cartItem);
            }, 300);
          }
          
          // ⭐ KRİTİK: Sayfadaki tüm key'leri Shopify'ın güncel key'leri ile senkronize et
          syncCartKeys(cart);
          
          if (typeof refreshCartTotals === 'function') refreshCartTotals(cart);
        })
        .catch(function (err) {
          console.error('Silme hatası:', err);
          if (cartItem) {
            cartItem.style.opacity = '1';
          }
          btn.disabled = false;
          btn.dataset.removing = 'false';
          btn.style.pointerEvents = '';
        });
      });
    });
    
    /* ── Sepet key'lerini Shopify ile senkronize et ── */
    function syncCartKeys(cart) {
      if (!cart || !cart.items) return;
      
      var cartItems = document.querySelectorAll('.cart-item');
      cartItems.forEach(function(domItem) {
        // Removing flag'li olan item'ları atla (silinmekte olanlar)
        if (domItem.getAttribute('data-removing') === 'true') return;
        
        var oldKey = domItem.getAttribute('data-key');
        if (!oldKey) return;
        
        // Shopify'dan güncel key'i bul
        var variantId = oldKey.split(':')[0];
        var matchingItem = cart.items.find(function(item) {
          return String(item.variant_id) === variantId;
        });
        
        if (matchingItem && matchingItem.key !== oldKey) {
          // Key değişmişse güncelle
          domItem.setAttribute('data-key', matchingItem.key);
          
          // Silme butonunu da güncelle
          var removeBtn = domItem.querySelector('.cart-item__remove');
          if (removeBtn) {
            removeBtn.setAttribute('data-key', matchingItem.key);
          }
          
          // Qty butonlarını da güncelle
          var qtyBtns = domItem.querySelectorAll('.cart-qty-btn');
          qtyBtns.forEach(function(qb) {
            qb.setAttribute('data-key', matchingItem.key);
          });
        }
      });
    }
/* ── Sepeti Temizle Butonu ── */
    var cartClearBtn = document.getElementById('cartClearBtn');
    if (cartClearBtn) {
      cartClearBtn.addEventListener('click', function () {
        if (cartClearBtn.disabled) return;
        
        if (!confirm('Sepetinizdeki tüm ürünleri silmek istediğinize emin misiniz?')) {
          return;
        }
        
        cartClearBtn.disabled = true;
        var btnSpan = cartClearBtn.querySelector('span');
        var originalText = btnSpan ? btnSpan.textContent : 'Sepeti Temizle';
        if (btnSpan) btnSpan.textContent = 'Temizleniyor...';
        
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-item').forEach(function (item, idx) {
            setTimeout(function () {
              item.style.transition = 'all 0.3s ease';
              item.style.opacity = '0';
              item.style.transform = 'translateX(-30px)';
            }, idx * 50);
          });
          
          setTimeout(function () {
            if (typeof showEmptyCart === 'function') {
              showEmptyCart();
            } else {
              window.location.reload();
            }
          }, 500);
          
          if (typeof updateCartBadge === 'function') updateCartBadge();
        })
        .catch(function () {
          cartClearBtn.disabled = false;
          if (btnSpan) btnSpan.textContent = originalText;
          alert('Sepet temizlenirken hata oluştu. Lütfen tekrar deneyin.');
        });
      });
    }
    
  }
  /* ========================================
     PAGE MODULE: FAQ PAGE
     (Sadece sayfaya \u00f6zel kod)
  ======================================== */
  if (document.querySelector('.faq-hero')) {
    // FAQ Accordion
    document.querySelectorAll('.faq-item__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const item = btn.closest('.faq-item');
        const isOpen = item.classList.contains('faq-item--open');
        // close all
        document.querySelectorAll('.faq-item--open').forEach(function (i) {
          i.classList.remove('faq-item--open');
          i.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('faq-item--open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // FAQ Search
    const faqSearchInput = document.getElementById('faqSearchInput');
    if (faqSearchInput) {
      faqSearchInput.addEventListener('input', function () {
        const query = faqSearchInput.value.toLowerCase();
        document.querySelectorAll('.faq-item').forEach(function (item) {
          const text = item.textContent.toLowerCase();
          item.style.display = text.includes(query) ? '' : 'none';
        });
        document.querySelectorAll('.faq-category').forEach(function (cat) {
          let hasVisible = false;
          cat.querySelectorAll('.faq-item').forEach(function (item) {
            if (item.style.display !== 'none') hasVisible = true;
          });
          cat.style.display = hasVisible ? '' : 'none';
        });
      });
    }
  }


  /* ========================================
     PAGE MODULE: CONTACT PAGE
     (Sadece sayfaya \u00f6zel kod)
  ======================================== */
  if (document.querySelector('.contact-form')) {
    const contactForm = document.getElementById('contactForm');
    const contactSuccess = document.getElementById('contactSuccess');
    if (contactForm) {
      contactForm.addEventListener('submit', function (e) {
        e.preventDefault();
        contactForm.style.display = 'none';
        if (contactSuccess) contactSuccess.style.display = 'block';
      });
    }
  }


  /* ========================================
     PAGE MODULE: SEARCH PAGE
     (Sadece sayfaya \u00f6zel kod)
  ======================================== */
  if (document.querySelector('.search-hero')) {
    document.querySelectorAll('.search-tag').forEach(function (t) {
      t.addEventListener('click', function () {
        const searchInput = document.getElementById('searchInput');
        if (searchInput) {
          searchInput.value = t.textContent;
          searchInput.focus();
        }
      });
    });
  }


  /* ========================================
     MODULE: FAQ ACCORDION (IIFE)
     SSS sayfas\u0131 a\u00e7\u0131l\u0131r/kapan\u0131r soru sistemi
  ======================================== */
  (function () {
    const faqItems = document.querySelectorAll('.faq-item');
    if (!faqItems.length) return;

    faqItems.forEach(item => {
      const question = item.querySelector('.faq-item__question');
      const answer = item.querySelector('.faq-item__answer');
      if (!question || !answer) return;

      question.addEventListener('click', () => {
        const isOpen = item.classList.contains('active');

        // Di\u011ferlerini kapat
        faqItems.forEach(other => {
          if (other !== item) {
            other.classList.remove('active');
            const otherAnswer = other.querySelector('.faq-item__answer');
            if (otherAnswer) otherAnswer.style.maxHeight = null;
          }
        });

        // Toggle
        item.classList.toggle('active');
        if (!isOpen) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        } else {
          answer.style.maxHeight = null;
        }
      });

      // Accessibility: Enter/Space ile a\u00e7
      question.setAttribute('role', 'button');
      question.setAttribute('tabindex', '0');
      question.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          question.click();
        }
      });
    });
  })();

  /* ========================================
     MODULE: FAQ SEARCH (IIFE)
     SSS sayfas\u0131 soru filtreleme
  ======================================== */
  (function () {
    const searchInput = document.querySelector('.faq-search__input');
    if (!searchInput) return;

    const faqItems = document.querySelectorAll('.faq-item');
    const faqCategories = document.querySelectorAll('.faq-category');

    searchInput.addEventListener('input', (e) => {
      const query = e.target.value.toLowerCase().trim();

      if (!query) {
        faqItems.forEach(item => item.style.display = '');
        faqCategories.forEach(cat => cat.style.display = '');
        return;
      }

      faqItems.forEach(item => {
        const question = item.querySelector('.faq-item__question');
        const answer = item.querySelector('.faq-item__answer-inner');
        const text = (question?.textContent || '') + ' ' + (answer?.textContent || '');
        item.style.display = text.toLowerCase().includes(query) ? '' : 'none';
      });

      // Bo\u015f kategorileri gizle
      faqCategories.forEach(cat => {
        const nextItems = [];
        let sibling = cat.nextElementSibling;
        while (sibling && !sibling.classList.contains('faq-category')) {
          if (sibling.classList.contains('faq-item')) nextItems.push(sibling);
          sibling = sibling.nextElementSibling;
        }
        const hasVisible = nextItems.some(item => item.style.display !== 'none');
        cat.style.display = hasVisible ? '' : 'none';
      });
    });
  })();

  /* ========================================
     MODULE: COUNTUP ANIMATION (IIFE)
     Hakk\u0131m\u0131zda sayfas\u0131 istatistik saya\u00e7lar\u0131
  ======================================== */
  (function () {
    const stats = document.querySelectorAll('.about-stats__number[data-count]');
    if (!stats.length) return;

    const animateCount = (el) => {
      const target = parseFloat(el.dataset.count);
      const decimals = parseInt(el.dataset.decimals || '0');
      const duration = 2000;
      const start = performance.now();

      const update = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        // easeOutExpo
        const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
        const current = eased * target;

        el.textContent = decimals > 0
          ? current.toFixed(decimals)
          : Math.floor(current).toLocaleString('tr-TR');

        if (progress < 1) requestAnimationFrame(update);
      };
      requestAnimationFrame(update);
    };

    // Intersection Observer ile g\u00f6r\u00fcn\u00fcr olunca ba\u015flat
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    stats.forEach(stat => observer.observe(stat));
  })();

  /* ========================================
     MODULE: AUTH FORMS (IIFE)
     Giri\u015f/Kay\u0131t sayfas\u0131 form i\u015flemleri
  ======================================== */
  (function () {
    // \u015eifre kurtarma formu toggle
    const forgotLink = document.querySelector('.auth-form__forgot');
    const loginForm = document.getElementById('loginForm');
    const recoverForm = document.getElementById('recoverForm');
    const backToLogin = document.getElementById('backToLogin');

    if (forgotLink && loginForm && recoverForm) {
      forgotLink.addEventListener('click', (e) => {
        e.preventDefault();
        loginForm.style.display = 'none';
        recoverForm.style.display = 'block';
      });

      if (backToLogin) {
        backToLogin.addEventListener('click', (e) => {
          e.preventDefault();
          recoverForm.style.display = 'none';
          loginForm.style.display = 'block';
        });
      }
    }

    // URL hash ile recover form a\u00e7 (#recover)
    if (window.location.hash === '#recover' && loginForm && recoverForm) {
      loginForm.style.display = 'none';
      recoverForm.style.display = 'block';
    }

    // \u015eifre g\u00f6ster/gizle toggle
    document.querySelectorAll('.password-toggle').forEach(toggle => {
      toggle.addEventListener('click', () => {
        const input = toggle.previousElementSibling;
        if (!input) return;
        const isPassword = input.type === 'password';
        input.type = isPassword ? 'text' : 'password';
        toggle.textContent = isPassword ? '\ud83d\ude48' : '\ud83d\udc41\ufe0f';
        toggle.setAttribute('aria-label', isPassword ? '\u015eifreyi gizle' : '\u015eifreyi g\u00f6ster');
      });
    });
  })();

  /* ========================================
     MODULE: ADDRESS MANAGEMENT (IIFE)
     Adres sayfas\u0131 form y\u00f6netimi
  ======================================== */
  (function () {
    // Yeni adres formu toggle
    const addBtn = document.getElementById('addAddressBtn');
    const addForm = document.getElementById('addAddressForm');

    if (addBtn && addForm) {
      addBtn.addEventListener('click', () => {
        const isHidden = addForm.style.display === 'none' || !addForm.style.display;
        addForm.style.display = isHidden ? 'block' : 'none';
        addBtn.textContent = isHidden ? '\u0130ptal' : '+ Yeni Adres Ekle';
      });
    }

    // D\u00fczenle formu toggle
    document.querySelectorAll('.edit-address-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const addressId = btn.dataset.addressId;
        const editForm = document.getElementById('editAddress_' + addressId);
        if (editForm) {
          editForm.style.display = editForm.style.display === 'none' ? 'block' : 'none';
        }
      });
    });

    // Sil onay\u0131
    document.querySelectorAll('.delete-address-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (!confirm('Bu adresi silmek istedi\u011finize emin misiniz?')) {
          e.preventDefault();
        }
      });
    });
  })();

  /* ========================================
     MODULE: SHARE BUTTONS (IIFE)
     Payla\u015f\u0131m butonlar\u0131
  ======================================== */
  (function () {
    document.querySelectorAll('.article-share__btn, .share-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const url = btn.href || btn.dataset.url;
        if (url) {
          window.open(url, '_blank', 'width=600,height=400,menubar=no,toolbar=no');
        }
      });
    });
  })();

  /* ========================================
     MODULE: BLOG TAG FILTER (IIFE)
     Blog sayfas\u0131 etiket filtreleme
  ======================================== */
  (function () {
    const tagLinks = document.querySelectorAll('.blog-tags .tag');
    if (!tagLinks.length) return;

    tagLinks.forEach(link => {
      if (window.location.pathname.includes(link.getAttribute('href'))) {
        link.classList.add('tag--active');
      }
    });
  })();

  /* ========================================
     MODULE: SCROLL ANIMATE (IIFE)
     Genel scroll animasyon kontrol\u00fc
  ======================================== */
  (function () {
    const animated = document.querySelectorAll('.scroll-animate');
    if (!animated.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    animated.forEach(el => observer.observe(el));
  })();

  /* ========================================
     MODULE: SMOOTH SCROLL (IIFE)
     Anchor link smooth scroll
  ======================================== */
  (function () {
    document.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener('click', (e) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  })();

  /* ========================================
     MODULE: BUNDLE BUILDER (Paket Ürün Seçici)
     Paket etiketli ürünlerde ürün seçim arayüzü
  ======================================== */
  (function () {
    var bundleBuilder = document.getElementById('bundleBuilder');
    if (!bundleBuilder) return;

    var maxSelections = parseInt(bundleBuilder.dataset.bundleCount) || 3;
    var variantId = bundleBuilder.dataset.variantId;
    var grid = document.getElementById('bundleGrid');
    var loading = document.getElementById('bundleLoading');
    var searchInput = document.getElementById('bundleSearch');
    var progressFill = document.getElementById('bundleProgressFill');
    var selectedCountEl = document.getElementById('bundleSelectedCount');
    var summaryPanel = document.getElementById('bundleSummary');
    var summaryList = document.getElementById('bundleSummaryList');
    var addBtn = document.getElementById('bundleAddToCart');
    var btnText = document.getElementById('bundleBtnText');

    var allProducts = [];
    var selectedProducts = [];

    /* ── Fetch all non-bundle products ── */
    function fetchProducts(page, collected) {
      page = page || 1;
      collected = collected || [];
      fetch('/products.json?limit=250&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.products && data.products.length > 0) {
            collected = collected.concat(data.products);
            if (data.products.length === 250) {
              fetchProducts(page + 1, collected);
            } else {
              processProducts(collected);
            }
          } else {
            processProducts(collected);
          }
        })
        .catch(function () {
          if (loading) loading.innerHTML = '<span>Ürünler yüklenirken hata oluştu. Lütfen sayfayı yenileyin.</span>';
        });
    }

    function processProducts(products) {
      /* Filter out bundle products (those tagged with 'paket') and current product */
      var currentProductUrl = window.location.pathname;
      allProducts = products.filter(function (p) {
        var isBundle = false;
        if (p.tags && typeof p.tags === 'string') {
          var tags = p.tags.split(',').map(function (t) { return t.trim().toLowerCase(); });
          isBundle = tags.indexOf('paket') > -1;
        } else if (Array.isArray(p.tags)) {
          isBundle = p.tags.some(function (t) { return t.toLowerCase() === 'paket'; });
        }
        var isSelf = p.handle && currentProductUrl.indexOf(p.handle) > -1;
        return !isBundle && !isSelf && p.variants && p.variants.length > 0 && p.variants[0].available;
      });

      renderGrid(allProducts);
    }

    /* ── Render product cards ── */
    function renderGrid(products) {
      if (loading) loading.style.display = 'none';

      // Remove previous cards (keep loading if it exists)
      var existingCards = grid.querySelectorAll('.bundle-card, .bundle-builder__empty');
      existingCards.forEach(function (c) { c.remove(); });

      if (products.length === 0) {
        grid.innerHTML += '<div class="bundle-builder__empty"><span class="bundle-builder__empty-icon">🔍</span>Ürün bulunamadı</div>';
        return;
      }

      products.forEach(function (product) {
        var card = document.createElement('div');
        card.className = 'bundle-card';
        card.dataset.productId = product.id;
        card.dataset.productTitle = product.title;
        card.dataset.productHandle = product.handle;

        var imgSrc = product.images && product.images.length > 0
          ? product.images[0].src
          : '';
        var imgTag = imgSrc
          ? '<img class="bundle-card__img" src="' + imgSrc.replace(/\.([a-z]+)\?/, '_300x300.$1?') + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
          : '<div class="bundle-card__img" style="display:flex;align-items:center;justify-content:center;color:#ccc;font-size:2rem">📦</div>';

        var isSelected = selectedProducts.some(function (sp) { return sp.id === product.id; });
        if (isSelected) card.classList.add('bundle-card--selected');

        // Check if we should disable (max reached and this one not selected)
        if (selectedProducts.length >= maxSelections && !isSelected) {
          card.classList.add('bundle-card--disabled');
        }

        var orderIndex = selectedProducts.findIndex(function (sp) { return sp.id === product.id; });

        card.innerHTML =
          '<div class="bundle-card__img-wrap">' +
            imgTag +
            '<div class="bundle-card__check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></div>' +
            '<div class="bundle-card__order">' + (orderIndex > -1 ? (orderIndex + 1) : '') + '</div>' +
          '</div>' +
          '<div class="bundle-card__info">' +
            '<div class="bundle-card__title">' + escapeHtml(product.title) + '</div>' +
          '</div>';

        card.addEventListener('click', function () {
          toggleProduct(product, imgSrc);
        });

        grid.appendChild(card);
      });
    }

    /* ── Toggle product selection ── */
    function toggleProduct(product, imgSrc) {
      var index = selectedProducts.findIndex(function (sp) { return sp.id === product.id; });

      if (index > -1) {
        // Deselect
        selectedProducts.splice(index, 1);
      } else {
        // Select (if not at max)
        if (selectedProducts.length >= maxSelections) return;
        selectedProducts.push({
          id: product.id,
          title: product.title,
          handle: product.handle,
          imgSrc: imgSrc || ''
        });
      }

      updateUI();
    }

    /* ── Remove product from summary ── */
    function removeProduct(productId) {
      selectedProducts = selectedProducts.filter(function (sp) { return sp.id !== productId; });
      updateUI();
    }

    /* ── Update all UI elements ── */
    function updateUI() {
      var count = selectedProducts.length;
      var percent = Math.round((count / maxSelections) * 100);

      // Progress
      if (progressFill) progressFill.style.width = percent + '%';
      if (selectedCountEl) selectedCountEl.textContent = count;

      // Button state
      if (count === maxSelections) {
        addBtn.disabled = false;
        btnText.textContent = 'Paketi Sepete Ekle';
        addBtn.classList.add('bundle-builder__add-btn--ready');
        setTimeout(function () { addBtn.classList.remove('bundle-builder__add-btn--ready'); }, 500);
      } else {
        addBtn.disabled = true;
        var remaining = maxSelections - count;
        btnText.textContent = remaining + ' Ürün Daha Seçin';
      }

      // Update card states
      var cards = grid.querySelectorAll('.bundle-card');
      cards.forEach(function (card) {
        var pid = parseInt(card.dataset.productId);
        var isSelected = selectedProducts.some(function (sp) { return sp.id === pid; });
        card.classList.toggle('bundle-card--selected', isSelected);
        card.classList.toggle('bundle-card--disabled', !isSelected && count >= maxSelections);

        var orderEl = card.querySelector('.bundle-card__order');
        if (orderEl) {
          var idx = selectedProducts.findIndex(function (sp) { return sp.id === pid; });
          orderEl.textContent = idx > -1 ? (idx + 1) : '';
        }
      });

      // Summary panel
      if (count > 0) {
        summaryPanel.style.display = '';
        summaryList.innerHTML = '';
        selectedProducts.forEach(function (sp) {
          var item = document.createElement('div');
          item.className = 'bundle-summary-item';
          var imgTag = sp.imgSrc
            ? '<img class="bundle-summary-item__img" src="' + sp.imgSrc.replace(/\.([a-z]+)\?/, '_80x80.$1?') + '" alt="' + escapeHtml(sp.title) + '">'
            : '<div class="bundle-summary-item__img" style="display:flex;align-items:center;justify-content:center;background:#f5f5fa;font-size:1rem">📦</div>';
          item.innerHTML = imgTag +
            '<span class="bundle-summary-item__name">' + escapeHtml(sp.title) + '</span>' +
            '<button class="bundle-summary-item__remove" aria-label="Kaldır" data-remove-id="' + sp.id + '">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
            '</button>';
          summaryList.appendChild(item);
        });

        // Attach remove listeners
        summaryList.querySelectorAll('.bundle-summary-item__remove').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            removeProduct(parseInt(btn.dataset.removeId));
          });
        });
      } else {
        summaryPanel.style.display = 'none';
      }
    }



    /* ── Add to Cart ── */
addBtn.addEventListener('click', function () {
      if (selectedProducts.length !== maxSelections) return;
      addBtn.disabled = true;
      btnText.textContent = 'Ekleniyor...';

      // Seçilen her ürün için ayrı bir line item oluştur
      // (Her ürünün kendi variant'ını sepete ekle, paket variant'ı değil)
      var bundleId = 'bundle-' + Date.now(); // Aynı paketin parçalarını eşleştirmek için

      var itemsPromises = selectedProducts.map(function (sp) {
        // Her ürünün ilk variant'ını bulmak için products.json'dan bulalım
        var fullProduct = allProducts.find(function (p) { return p.id === sp.id; });
        if (!fullProduct || !fullProduct.variants || !fullProduct.variants[0]) {
          return null;
        }
        return {
          id: fullProduct.variants[0].id,
          quantity: 1,
          properties: {
            '_bundle': maxSelections + 'li Paket',
            '_bundle_group': bundleId
          }
        };
      }).filter(Boolean);

      if (itemsPromises.length !== maxSelections) {
        btnText.textContent = 'Hata! Tekrar Deneyin';
        addBtn.disabled = false;
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsPromises })
      })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) { throw new Error(err.description || 'Hata'); });
        }
        return r.json();
      })
.then(function (result) {
        btnText.textContent = '✓ Sepete Eklendi!';
        addBtn.style.background = 'var(--color-accent)';
        addBtn.style.borderColor = 'var(--color-accent)';
        
        // Sipariş notunu temizle
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: '' })
        });
        
        if (typeof updateCartBadge === 'function') updateCartBadge();
        if (typeof showCartToast === 'function') showCartToast(maxSelections + 'li Paket');

        setTimeout(function () {
          window.location.href = '/cart';
        }, 1200);
      })
      .catch(function (err) {
        addBtn.disabled = false;
        btnText.textContent = 'Hata! Tekrar Deneyin';
        console.error('Bundle add to cart error:', err);
        setTimeout(function () {
          btnText.textContent = 'Paketi Sepete Ekle';
        }, 2000);
      });
    });

    /* ── Helpers ── */
    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    function formatMoney(cents) {
      if (typeof cents === 'string') cents = parseFloat(cents);
      // Shopify /products.json returns price as string like "250.00"
      var amount = parseFloat(cents);
      if (isNaN(amount)) return '0,00TL';
      return amount.toFixed(2).replace('.', ',') + 'TL';
    }

    /* ── Initialize ── */
    fetchProducts();
  })();

});